/* eslint-disable react/button-has-type */
import clsx from 'clsx';
import getLinkProps from '@/lib/getLinkProps';
import { ActiveLink, Control } from '@/components';

import styles from './ShopsView.module.scss';

const ShopsViews = ({ isStatic }) => {
	const [shopsMapHref, shopsMapAs] = getLinkProps({ type: 'shops-map' });
	const [shopsListHref, shopsListAs] = getLinkProps({ type: 'shops-list' });

	return (
		<div className={clsx({ [styles.isStatic]: isStatic }, styles.views)}>
			<div className={styles.tabs}>
				<div className={styles.buttons}>
					<ActiveLink activeClassName={styles.active} href={shopsListHref} as={shopsListAs}>
						<Control className={styles.button} tag='a'>
							Список
						</Control>
					</ActiveLink>

					<ActiveLink activeClassName={styles.active} href={shopsMapHref} as={shopsMapAs}>
						<Control className={styles.button} tag='a'>
							На карте
						</Control>
					</ActiveLink>
				</div>
			</div>
		</div>
	);
};

export default ShopsViews;
